import Tags from "screens/private/readers-tags/tags";
export default Tags;
